module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume008.fc9099a0.webp";